export default __webpack_public_path__ + "static/media/warning.1cc81e59.svg";